<template>
    <v-footer name="footer" app class="py-1" >
        <v-card width="100%" >
            <v-card-text class="text-center pa-0">
                <span>Copyright &copy; {{
                        new Date().getFullYear()
                    }} NextEra IOT, LLC - All rights Reserved.</span>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script setup>
</script>

<style scoped>

</style>
